import React, { Fragment } from 'react'
import { Button, Card, Modal, Table } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { Dependentes } from '../../../Common'
import { formatDepDataNasc } from '../utils/formatDepDataNasc'

export default function DependentesSection({
  dependentes,
  modalDependenteIndex,
  isPacienteCadastrado,
  canAddItems,
  onSetModalDependenteIndex,
  onCloseModalDependente,
  setDependente,
  removeDependente,
}) {
  if (!dependentes.length) return null

  const dependenteEditDisabled = (dep) => !canAddItems || (isPacienteCadastrado && dep.id)

  return (
    <Fragment>
      <div className="d-none d-md-block table-responsive paciente-form-list-wrap mb-2">
        <Table hover borderless size="sm" className="paciente-form-list-table mb-0">
          <thead className="border-bottom">
            <tr className="text-muted small">
              <th>#</th>
              <th>Nome</th>
              <th>Nascimento</th>
              <th>CPF</th>
              <th>RG</th>
              <th className="text-right">Ações</th>
            </tr>
          </thead>
          <tbody>
            {dependentes.map((dep, index) => (
              <tr key={index}>
                <td className="text-muted">{index + 1}</td>
                <td className="text-truncate" style={{ maxWidth: 200 }} title={dep.nome}>
                  {dep.nome || '—'}
                </td>
                <td>{formatDepDataNasc(dep.dataNascimento)}</td>
                <td className="text-nowrap">{dep.cpf || '—'}</td>
                <td className="text-nowrap">{dep.rg || '—'}</td>
                <td className="text-right text-nowrap">
                  <Button
                    type="button"
                    variant="link"
                    className="p-1 mr-1"
                    onClick={() => onSetModalDependenteIndex(index)}
                    disabled={dependenteEditDisabled(dep)}
                    title="Editar"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>
                  {!dep.id && !dependenteEditDisabled(dep) && (
                    <Button type="button" variant="link" className="p-1 text-danger" onClick={() => removeDependente(index)} title="Excluir">
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <div className="d-md-none">
        {dependentes.map((dep, index) => {
          const dis = dependenteEditDisabled(dep)
          return (
            <Card key={index} className="paciente-dependente-card border mb-2">
              <Card.Body className="py-2 px-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="min-w-0 pr-2">
                    <div className="text-muted small mb-0">Dependente {index + 1}</div>
                    <div className="font-weight-medium text-dark text-break">{dep.nome || '—'}</div>
                    <div className="small text-muted mt-1">
                      {formatDepDataNasc(dep.dataNascimento)} · {dep.cpf || '—'}
                    </div>
                  </div>
                  <div className="d-flex flex-column align-items-end flex-shrink-0">
                    <Button
                      type="button"
                      size="sm"
                      variant="outline-primary"
                      className="mb-1"
                      onClick={() => onSetModalDependenteIndex(index)}
                      disabled={dis}
                    >
                      <FontAwesomeIcon icon={faEdit} className="mr-1" />
                      Editar
                    </Button>
                    {!dep.id && !dis && (
                      <Button type="button" size="sm" variant="outline-danger" onClick={() => removeDependente(index)}>
                        Excluir
                      </Button>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          )
        })}
      </div>

      <Modal
        show={modalDependenteIndex !== null}
        onHide={onCloseModalDependente}
        centered
        dialogClassName="paciente-form-item-modal__dialog paciente-form-item-modal__dialog--dependente"
        className="paciente-form-item-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Dependente {modalDependenteIndex !== null ? modalDependenteIndex + 1 : ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalDependenteIndex !== null && (
            <Dependentes
              embedded
              index={modalDependenteIndex}
              dependente={dependentes[modalDependenteIndex]}
              removeDependente={() => {}}
              onChange={setDependente}
              disableAll={!canAddItems || (isPacienteCadastrado && !!dependentes[modalDependenteIndex]?.id)}
            />
          )}
        </Modal.Body>
        <Modal.Footer className="border-top-0 pt-0">
          <Button type="button" variant="primary" onClick={onCloseModalDependente}>
            Concluir
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  )
}
